var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { staticClass: "form form--has-fixed-group", attrs: { novalidate: "" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.success,
              expression: "success",
            },
          ],
          ref: "success",
          staticClass: "alert alert--success",
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.currentUser
                  ? "Your password has been updated"
                  : "User password has been updated"
              ) +
              "\n\t"
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid" }, [
        _c("div", { staticClass: "col-12 col-md-6" }, [
          _c("fieldset", { staticClass: "form__group" }, [
            _c("legend", [_vm._v("Change Password")]),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.currentPassword,
                    expression: "formData.currentPassword",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "form__control",
                attrs: {
                  id: "current-password",
                  type: "password",
                  name: "currentPassword",
                  placeholder: "Enter existing password here...",
                  required: "",
                },
                domProps: { value: _vm.formData.currentPassword },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.formData,
                      "currentPassword",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form__label",
                  attrs: { for: "current-password" },
                },
                [_vm._v("Existing Password")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("currentPassword"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.newPassword,
                    expression: "formData.newPassword",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "form__control",
                attrs: {
                  id: "new-password",
                  type: "password",
                  name: "newPassword",
                  placeholder: "Enter new password here...",
                  required: "",
                },
                domProps: { value: _vm.formData.newPassword },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "newPassword", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form__label", attrs: { for: "new-password" } },
                [_vm._v("New Password")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("newPassword"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.newPassword_confirmation,
                    expression: "formData.newPassword_confirmation",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "form__control",
                attrs: {
                  id: "confirm-password",
                  type: "password",
                  name: "confirmPassword",
                  placeholder: "Re-enter new password here...",
                  required: "",
                },
                domProps: { value: _vm.formData.newPassword_confirmation },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.formData,
                      "newPassword_confirmation",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form__label",
                  attrs: { for: "confirm-password" },
                },
                [_vm._v("Confirm New Password")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("confirmPassword"))),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form__group form__group--submit-fixed" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "wait",
                rawName: "v-wait:disabled",
                value: _vm.waitName,
                expression: "waitName",
                arg: "disabled",
              },
            ],
            staticClass: "btn btn--primary",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [_vm._v("Save Changes")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }